import { GunbarrelView } from "stores/wellCardPanel";
import styled from "styled-components";

import SegmentedToggle, { SegmentedVariant } from "components/shared/SegmentedToggle";

export interface GunbarrelViewSwitcherProps {
  view: GunbarrelView;
  onChange: (view: GunbarrelView) => void;
}

/**
 * The control the shapefile filter uses for its match mode, reused: EVA's
 * shared `SegmentedToggle` in its base variant. Labels only — the icons the
 * panel used to draw here said nothing the words do not.
 */
export function GunbarrelViewSwitcher({
  view,
  onChange
}: GunbarrelViewSwitcherProps): JSX.Element {
  return (
    <Switcher
      variant={SegmentedVariant.Base}
      aria-label="Gunbarrel view"
      value={view}
      options={[
        { value: "xda", label: "XDA" },
        { value: "3d", label: "3D Viewer" }
      ]}
      onChange={(value) => onChange(value as GunbarrelView)}
      data-testid="gunbarrel-view-switcher"
    />
  );
}

const Switcher = styled(SegmentedToggle)`
  flex: none;
`;
